<template>
  <div>
    <autoLogout />
    <loader :loader="loader || sending" />
    <div class="wrapper-content">
      <encabezado :elementos="encabezado" v-if="showAction(1)" />
      <v-card
        v-if="showAction(1)"
        :class="[listaPendDisp.length < 6 ? 'calendar' : '']"
      >
        <v-card-text>
          <v-row align="baseline" justify="center">
            <branch-offices-list
              :classOfDiv="cols"
              style="padding-top: 22px"
              v-on:triggerChange="branchOfficeSelected"
              :model="idBranchOfficeSelected"
            />

            <v-col md="3">
              <vc-date-picker
                v-model="date"
                is-range
                color="green"
                :is-dark="!$utilFront.isDarkTheme()"
                :max-date="new Date()"
              >
                <template v-slot="{ inputEvents }">
                  <div class="flex justify-center items-center">
                    <v-text-field
                      v-on="inputEvents.start"
                      :value="dateCompuded"
                      label="Seleccione fecha"
                      :append-icon="validData ? 'mdi-eraser' : 'mdi-calendar'"
                      @click:append="
                        date = '';
                        listAll();
                      "
                      :disabled-input="validData"
                    ></v-text-field>
                  </div>
                </template>
              </vc-date-picker>
            </v-col>
            <v-col>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="listaPendDisp"
            :search="search"
            :items-per-page="10"
            :footer-props="{
              'items-per-page-text': 'Elementos por página',
              'items-per-page-all-text': 'Todo',
            }"
            no-results-text="Sin resultados coincidentes con la búsqueda"
            loading-text="Cargando..."
            no-data-text="Sin resultados disponibles"
            dense
            fixed-header
            height="auto"
          >
            <template v-slot:[`item.prescriptionDate`]="{ item }">
              {{ $utilFront.formatDateTime(item.prescriptionDate) }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip
                top
                v-if="$utilFront.withPermission($prm.MODULE_PHARMACY_DISPENSE)"
              >
                <template v-slot:activator="{ on, attrs }">
                  <!-- getPrescription -->
                  <v-btn @click="getPrescriptionData(item)" icon>
                    <v-icon color="blue" v-bind="attrs" v-on="on">
                      mdi-pill
                    </v-icon>
                  </v-btn>
                </template>
                <span>Dispensar</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    color="error"
                    @click="openDialogCancel(item)"
                  >
                    <v-icon>mdi-stop</v-icon>
                  </v-btn>
                </template>
                <span>Cancelar</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <encabezado :elementos="titleDispense" v-if="showAction(2)" />
      <v-card v-if="showAction(2)">
        <validation-observer>
          <v-card-text>
            <v-container>
             
              <v-row
                justify="space-around"
                v-if="
                  flagComponentInfo &&
                  objPrescription &&
                  objPrescription.idPatient
                "
              >
                <v-col cols="12" md="12" sm="12">
                  <patient-information :model="objPrescription" />
                </v-col>
              </v-row>
              <v-form>
                <!-- <v-row class="mb-2">
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Nombre"
                      rules="required"
                    >
                      <v-text-field
                        label="Nombre"
                        v-model="objPrescription.fullNamePatient"
                        prepend-icon="mdi-account"
                        :error-messages="errors"
                        :counter="100"
                        required
                        :disabled="true"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row> -->

                <v-row dense class="text-left mt-4">
                  <v-col cols="12" sm="12" md="12"
                    ><v-banner
                      color="primary"
                      class="mb-4"
                      dark
                      shaped
                      single-line
                      align="left"
                    >
                      Información de receta
                    </v-banner>
                  </v-col>
                </v-row>

                <v-row dense class="ml-2 mb-4">
                  <v-col md="4" sm="12">
                    <strong>Id receta: </strong>
                    {{ objPrescription.idPrescription }}</v-col
                  >
                  <v-col md="4" sm="12">
                    <strong>Fecha de solicitud: </strong>
                    {{
                      $utilFront.formatDateTime(
                        objPrescription.prescriptionDate
                      )
                    }}
                  </v-col>
                  <v-col md="4" sm="12">
                    <strong>Fecha de dispensación: </strong>
                    {{ objPrescription.dispenseDate }}
                  </v-col>
                </v-row>

                <v-row class="mb-2">
                  <!-- <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Clave de receta"
                      rules="required"
                    >
                      <v-text-field
                        label="Clave de receta"
                        v-model="objPrescription.idPrescription"
                        prepend-icon="fas fa-pills"
                        :error-messages="errors"
                        required
                        :disabled="true"
                      ></v-text-field>
                    </validation-provider>
                  </v-col> -->
                  <!-- <v-col>

                    <VueCtkDateTimePicker
                      :no-value-to-custom-elem="true || false"
                      :min-date="currentDate"
                      disabled
                      button-now-translation="Ahora"
                    >
                      <v-text-field
                        disabled
                        clearable
                        :value="
                          $utilFront.formatDateTime(
                            objPrescription.prescriptionDate
                          )
                        "
                        prepend-icon="mdi-calendar"
                        label="Fecha y hora de solicitud"
                        no-autocomplete
                        required
                      >
                      </v-text-field>
                    </VueCtkDateTimePicker>
                  </v-col> -->
                  <!-- <v-col>
                    <VueCtkDateTimePicker
                      :no-value-to-custom-elem="true || false"
                      v-model="objPrescription.dispenseDate"
                      :min-date="currentDate"
                      disabled
                      button-now-translation="Ahora"
                    >
                      <v-text-field
                        disabled
                        clearable
                        :value="objPrescription.dispenseDate"
                        prepend-icon="mdi-calendar"
                        label="Fecha y Hora de dispensación"
                        no-autocomplete
                        required
                      ></v-text-field>
                    </VueCtkDateTimePicker>
                  </v-col> -->
                </v-row>

                <v-row dense class="text-left mt-4">
                  <v-col cols="12" sm="12" md="12"
                    ><v-banner
                      color="blue-grey lighten-5"
                      class="mb-4 black--text"
                      shaped
                      single-line
                      align="left"
                    >
                      Productos recetados
                    </v-banner>
                  </v-col>
                </v-row>

                <validation-observer ref="dispenseRecipe" v-slot="{ invalid }">
                  <v-row
                    justify="center"
                    align="center"
                    class="text-center mb-3"
                  >
                    <v-col cols="12" md="8" sm="12">
                      <v-autocomplete
                        v-model="stock"
                        :items="stocks"
                        label="Producto"
                        no-data-text="Sin resultados disponibles"
                        clearable dense
                      />
                    </v-col>
                    <v-col cols="12" md="3" sm="12">
                      <validation-provider
                        v-slot="{ errors }"
                        name="Cantidad"
                        rules="required|numeric|min_value:1"
                      >
                        <v-text-field
                          dense
                          clearable
                          required
                          autocomplete="off"
                          :error-messages="errors"
                          v-model.trim="quantity"
                          label="Cantidad*"
                          clear-icon="mdi-eraser"
                        >
                        </v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col cols="12" md="1" sm="12">
                      <v-btn
                        fab
                        dark
                        color="secondary"
                        :disabled="invalid || sending"
                        @click="validateStockPrescription()"
                      >
                        <v-icon dark> mdi-plus </v-icon>
                      </v-btn>
                    </v-col>
                    <v-col cols="12" md="2" sm="12" v-if="stock">
                      <h3 class="font-weight-black mb-5">
                        Existencia:
                        <span class="error--text">{{ stock.quantity }}</span>
                      </h3>
                    </v-col>
                  </v-row>
                </validation-observer>

                <v-row>
                  <v-col class="mb-2">
                    <v-text-field
                      v-model="findMedicine"
                      append-icon="mdi-magnify"
                      label="Buscar"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-data-table
                  :headers="headersDispense"
                  :items="productsPrescription"
                  :search="findMedicine"
                  :items-per-page="-1"
                  :footer-props="{
                    'items-per-page-text': 'Elementos por página',
                    'items-per-page-all-text': 'Todo',
                  }"
                  no-results-text="Sin resultados coincidentes con el búsqueda"
                  loading-text="Cargando..."
                  no-data-text="Sin resultados disponibles"
                  dense
                  fixed-header
                  height="auto"
                >
                  <template v-slot:[`item.fullName`]="{ item }">
                    <small>{{ item.fullName }}</small>
                  </template>
                  <template v-slot:[`item.stocks`]="{ item }">
                    <span
                      v-for="(stock, subindex) in item.stocks"
                      :key="subindex"
                    >
                      {{ stock.lot }}<br />
                    </span>
                  </template>
                  <template v-slot:[`item.actions`]="{ item, index }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          @click="undo(item, index)"
                          :disabled="
                            sending || $utilFront.isEmptyList(item.stocks)
                          "
                        >
                          <v-icon color="warning" v-bind="attrs" v-on="on">
                            mdi-eraser
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Deshacer</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-form>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-row align="center" justify="center" class="py-3">
              <v-col>
                <v-row align="center" justify="center">
                  <v-col class="text-center">
                    <v-btn plain color="error" @click="changeAction(1)">
                      <v-icon left>mdi-close</v-icon>
                      Volver
                    </v-btn>
                  </v-col>
                  <v-col class="text-center">
                    <v-btn
                      class="primary"
                      @click="dispensePrescription()"
                      :disabled="sending || !noDispense"
                      >Dispensar receta <v-icon right>mdi-check</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-actions>
        </validation-observer>
      </v-card>

      <v-dialog v-model="prescriptionDialog" persistent max-width="1000">
        <validation-observer v-slot="{ invalid }" ref="cancelPrescription">
          <validation-provider
            v-slot="{ errors }"
            name="Motivo de cancelación"
            rules="required|min:15"
          >
            <v-card>
              <v-card-title class="text-h6 text-center">
                ¿Desea cancelar la receta?
              </v-card-title>
              <v-card-text>
                <!-- {{  prescription }} -->
                <v-row
                  justify="space-around"
                  v-if="
                    prescription &&
                    prescription.idPatient
                  "
                >
                  <v-col cols="12" md="12" sm="12">
                    <patient-information :model="prescription" />
                  </v-col>
                </v-row>
                <v-row dense class="text-left mt-4">
                  <v-col cols="12" sm="12" md="12"
                    ><v-banner
                      color="primary"
                      class="mb-4"
                      dark
                      shaped
                      single-line
                      align="left"
                    >
                    <v-icon class="mr-2">mdi-folder</v-icon>
                      Información de receta
                    </v-banner>
                  </v-col>
                </v-row>

                <v-row dense class="ml-2 mb-4 mt-4">
                  <v-col md="4" sm="12">
                    <strong>Id receta: </strong>
                    {{ prescription.idPrescription }}</v-col
                  >
                  <v-col md="4" sm="12">
                    <strong>Fecha de solicitud: </strong>
                    {{
                      $utilFront.formatDateTime(
                        prescription.prescriptionDate
                      )
                    }}
                  </v-col>
                  <v-col md="4" sm="12" v-if="prescription.dispenseDate">
                    <strong>Fecha de dispensación: </strong>
                    {{ prescription.dispenseDate }}
                  </v-col>
                </v-row>
               
                
                <div
                  @click.right.prevent
                  @copy.prevent
                  @paste.prevent
                  ondrop="return false;"
                  
                >
                  <v-textarea
                    outlined
                    v-model="reasonPrescription"
                    :value="reasonPrescription"
                    :error-messages="errors"
                    label="Motivo de la cancelación"
                    id="cancellationPrescription"
                    required
                    counter
                  >
                  </v-textarea>
                </div>
              </v-card-text>
              <v-card-actions >
                <v-spacer></v-spacer>
                <v-btn
                  color="error"
                  text
                  @click="
                    (prescriptionDialog = false), clearCancelPrescription()
                  "
                  :disabled="sending"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="primary"
                  text
                  @click="cancelPrescription()"
                  :disabled="sending || invalid"
                >
                  Sí, cancelar
                </v-btn>
              </v-card-actions>
            </v-card>
          </validation-provider>
        </validation-observer>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import {
  PrescriptionRequest,
  PharmacyPrescriptionRequest,
  StockRequest,
} from "@/core/request";
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "@/components/Sidebar.vue";
import Datatable from "@/components/Datatable.vue";
import BtnAccion from "@/components/btnAccion.vue";
import moment from "moment";
import { mapActions } from "vuex";
import AutoLogout from "../../components/AutoLogout.vue";
import Loader from "../../components/Loader.vue";
import BranchOfficesList from "../../components/BranchOfficesList.vue";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { required } from "vee-validate/dist/rules";

import PatientInformation from "@/app/components/common/patient/PatientInformation.vue";
extend("required", {
  ...required,
  message: "{_field_} no puede quedar vacío",
});

export default {
  components: {
    Sidebar,
    Encabezado,
    Datatable,
    BtnAccion,
    AutoLogout,
    Loader,
    BranchOfficesList,
    ValidationObserver,
    ValidationProvider,
    PatientInformation,
  },
  data: () => ({
    action: 1,
    loader: false,
    date: "",
    encabezado: {
      icono: "mdi-pill",
      texto: "Pendientes por dispensar | Farmacia",
    },
    listaPendDisp: [],
    icono: "mdi-pencil",
    headers: [
      { text: "Id Receta", value: "idPrescription", align: "center" },
      { text: "Id Paciente", value: "idPatient", align: "center" },
      {
        text: "Nombre del paciente",
        value: "fullNamePatient",
        align: "center",
      },
      { text: "Nombre del doctor", value: "nameDoctor", align: "center" },
      {
        text: "Fecha y hora de solicitud",
        value: "prescriptionDate",
        align: "center",
      },
      { text: "Acciones", value: "actions", sortable: false, align: "center" },
    ],
    search: "",
    findMedicine: "",
    btnHisDisp: {
      route: "/farmacia/historial",
      icon: "mdi-history",
      text: "Historial de dispensaciones",
      tooltip: "Ver historial de dispensaciones",
    },
    reasonPrescription: "",
    sending: false,
    idBranchOfficeSelected: null,
    cols: "col-md-3 col-xl-3 col-sm-12",
    prescription: {
      idPrescription: "",
      patient: { idPatient: "", person: {} },
    },
    prescriptionDialog: false,

    // ! DISPENSE PRESCRIPTION
    titleDispense: { icono: "mdi-pill", texto: "Dispensar prescripción" },
    headersDispense: [
      { text: "Clave", value: "product_key" },
      { text: "Producto", value: "fullName", width: "30%" },
      { text: "Recetado", value: "request" },
      { text: "Dispensado", value: "quantity" },
      { text: "Lotes", value: "stocks", sortable: false },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    objPrescription: {
      patient: { idPatient: "", person: {} },
    },
    productsPrescription: [],
    dispensed: {},
    stocks: [],
    stock: {
      quantity: 0,
    },
    quantity: 0,
    idBranchOffice: null,
    noDispense: false,
    flagComponentInfo: false,
  }),
  created() {
    this.validBrowserTab();
    this.listAll();
  },
  computed: {
    dateCompuded() {
      if (this.date == "" || this.date == null || this.date == undefined) {
        return "";
      }

      return `${moment(this.date.start).format("DD/MM/YYYY")} al ${moment(
        this.date.end
      ).format("DD/MM/YYYY")}`;
    },
    validData() {
      if (this.date == "" || this.date == null || this.date == undefined) {
        return false;
      }
      this.listAll();
      return true;
    },
    currentDate() {
      return moment(new Date()).format("YYYY-MM-DD HH:mm:ss a");
    },
  },
  watch: {
    productsPrescription: function () {
      for (let y in this.productsPrescription) {
        if (this.productsPrescription[y].quantity > 0) {
          this.noDispense = true;
        } else if (this.productsPrescription[y].quantity == 0) {
          return (this.noDispense = false);
        }
      }
    },
  },
  methods: {
    ...mapActions(["validTab", "unauthorized"]),

    showAction(action) {
      return this.action == action;
    },
    changeAction(action) {
      if (action == 1) {
        this.flagComponentInfo = false;
        this.action = action;
        this.stock = {};
        this.findMedicine = "";
        this.listAll();
      } else if (action == 2) {
        this.action = action;
      }
    },

    validBrowserTab() {
      this.validTab();
    },
    listAll() {
      this.loader = true;

      let params = {
        status: 1,
        idBranchOffice: this.$utilFront.nonEmpty(
          this.idBranchOfficeSelected,
          this.$utilFront.getIdBranchOffice()
        ),
      };

      params = Object.assign(params, this.date);

      if (
        this.$utilFront.nonEmpty(params.start) &&
        this.$utilFront.nonEmpty(params.end)
      ) {
        params.start = this.$utilFront.startOfDay(params.start);
        params.end = this.$utilFront.endOfDay(params.end);
      }

      PrescriptionRequest.listAllPrescriptionByStatus(params)
        .then((res) => {
          let { data, code } = res.data;
          if (code == 200) {
            this.listaPendDisp = data;
          } else {
            this.$utilFront.notifications(
              data || "Error al listar información.",
              "ERROR"
            );
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },
    clearCancelPrescription() {
      this.$refs.cancelPrescription.reset();
      this.reasonPrescription = "";
    },
    branchOfficeSelected(selected) {
      this.idBranchOfficeSelected = selected;
      this.listAll();
    },
    openDialogCancel(item) {
      this.prescription = Object.assign(item, {});
      this.prescriptionDialog = true;
    },
    cancelPrescription() {
      if (!this.sending) {
        this.sending = true;

        let statusCancel = 3;
        let params = {
          idPrescription: this.prescription.idPrescription,
          status: statusCancel,
          reasonPrescription: this.reasonPrescription,
        };

        PrescriptionRequest.updateStatus(params)
          .then((res) => {
            let { status, code, data } = res.data;

            if (code == 200 && data == true) {
              this.listAll();
              this.$utilFront.notifications("Receta cancelada.", "SUCCESS");
              this.reasonPrescription = "";
            } else {
              this.$utilFront.notifications(
                "Ocurrió un error interno",
                "ERROR"
              );
            }
          })
          .catch(this.catchError)
          .finally(() => {
            this.sending = false;
            this.prescriptionDialog = false;
            this.clearCancelPrescription();
          });
      }
    },

    // ! DISPENSE CONSULTATION
    getPrescriptionData(item) {
      this.flagComponentInfo = true;
      this.objPrescription = item;
      this.idBranchOffice =
        this.idBranchOfficeSelected != null
          ? this.idBranchOfficeSelected
          : this.$utilFront.getIdBranchOffice();
      this.changeAction(2);
      this.getProductByPrescription(this.objPrescription.idPrescription);
      this.getStockProductsByPrescription(this.objPrescription.idPrescription);

      this.objPrescription.prescriptionDate =
        this.objPrescription.prescriptionDate;
      this.objPrescription.dispenseDate = moment(new Date()).format(
        "DD/MM/YYYY HH:mm"
      );
    },
    getProductByPrescription(idPrescription) {
      PharmacyPrescriptionRequest.listPharmacyPrescriptionByPrescription({
        idPrescription: idPrescription,
      }).then((res) => {
        this.loader = true;

        if (res.data.code === 200 && res.data.status === "OK") {
          this.productsPrescription = res.data.data.map((product) => {
            return {
              idProduct: product.products.idProduct,
              product_key: product.products.product_key,
              name: product.products.name,
              text: product.products.text,
              request: product.request,
              fullName: product.products.fullName,
              quantity: product.dispensed,
              dispensed: product.dispensed,
              stocks: product.stocks,
            };
          });
          for (let y in this.productsPrescription) {
            if (this.productsPrescription[y].quantity > 0) {
              this.noDispense = true;
            } else if (this.productsPrescription[y].quantity == 0) {
              this.noDispense = false;
            }
          }
          this.loader = false;
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    getStockProductsByPrescription(idPrescription) {
      StockRequest.listAllByPrescriptionAndBranchOffice({
        idBranchOffice: this.$utilFront.getIdBranchOffice(),
        statusStock: [1],
        idPrescription: idPrescription,
      }).then((res) => {
        this.loader = true;
        let { data, response, message } = res.data;
        if (response) {
          this.stocks = data.map((it) => {
            let text = it.product.product_key + " | ";
            text += it.expirationDateText + " - ";
            text += "Lote: " + it.lot + " | ";
            text += it.product.name;
            it.quantityInital = Object.assign(it.quantity, 0);
            return { text: text, value: it };
          });
        } else {
          this.stocks = [];
          this.$utilFront.notifications(
            "Sin productos disponibles.",
            "WARNING"
          );
        }
        this.loader = false;
      });
    },

    dispensePrescription() {
      // if (this.quantity == 0) {
      //   this.$swal({
      //     title: "¡Atención!",
      //     icon: "warning",
      //     text:
      //       "La receta será dispensada en 0, ¿desea continuar con la acción?",
      //     showCancelButton: true,
      //     allowOutsideClick: false,
      //     allowEscapeKey: false,
      //     reverseButtons: true,
      //     confirmButtonColor: "#4CAF50",
      //     cancelButtonColor: "#d33",
      //     confirmButtonText: "Aceptar",
      //     cancelButtonText: "Cancelar",
      //   }).then((result) => {
      // if (result.isConfirmed) {
      this.sending = true;
      this.loader = true;
      let statusDispensed = 2;
      PrescriptionRequest.updateStatus({
        idPrescription: this.objPrescription.idPrescription,
        status: statusDispensed,
      })
        .then((res) => {
          let { code, data } = res.data;

          if (code == 200 && data == true) {
            this.$utilFront.notifications("Receta dispensada.", "SUCCESS");
            this.changeAction(1);
          } else {
            this.$utilFront.notifications(
              data || "Ocurrió un error durante el registro.",
              "ERROR"
            );
          }
        })
        .catch(this.$utilFront.errorhttp)
        .finally(() => {
          this.sending = false;
          this.loader = false;
        });
      // }
      // });
      // }
    },
    undo(item, index) {
      this.stocks = this.stocks.map((it) => {
        for (let i = 0; i < item.stocks.length; i++) {
          if (it.value.idStock == item.stocks[i].idStock) {
            this.deleteStockPrescription(
              {
                idStock: it.value.idStock,
                idPrescription: this.objPrescription.idPrescription,
              },
              it.value.idStock
            );
          }
        }
        return it;
      });
      this.productsPrescription[index].stocks = [];
      this.productsPrescription[index].quantity = 0;
      this.noDispense = false;
    },
    clearInputs() {
      this.$refs.dispenseRecipe.reset();
      this.quantity = 0;
      this.stock = {};
    },
    validateStockPrescription() {
      if (this.quantity > this.stock.quantity) {
        this.$utilFront.notifications(
          `${this.stock.quantity} disponibles en almácen`,
          "WARNING"
        );
        this.clearInputs();
      } else {
        let added = false;
        let exceedsAmount = false;
        this.quantity = Number(this.quantity);
        this.productsPrescription = this.productsPrescription.map((it) => {
          if (this.stock.product.idProduct == it.idProduct) {
            if (
              this.quantity <= it.request &&
              it.quantity < it.request &&
              it.quantity + this.quantity <= it.request
            ) {
              let data = {
                idStock: this.stock.idStock,
                quantity: this.quantity,
                lot: this.stock.lot,
              };
              let add = true;
              if (this.$utilFront.nonEmptyList(it.stocks)) {
                for (let i = 0; i < it.stocks.length; i++) {
                  const element = it.stocks[i];
                  if (element.idStock == this.stock.idStock) {
                    add = false;
                  }
                }
              } else {
                it.stocks = [];
              }

              it.quantity = it.quantity + this.quantity;
              this.stock.quantity = this.stock.quantity - this.quantity;
              // this.stock.quantityRequest =   Number(this.stock.quantityRequest || 0) + this.quantity;

              if (add) {
                it.stocks.push(data);
              }
              // if (this.quantity > 0) {
              //   this.noDispense = true;
              // }
              this.saveStockPrescription(
                {
                  idStock: this.stock.idStock,
                  quantity: this.quantity,
                  idPrescription: this.objPrescription.idPrescription,
                },
                this.stock.idStock
              );

              added = true;
            } else {
              exceedsAmount = true;
            }
          }
          return it;
        });
        if (exceedsAmount) {
          this.$utilFront.notifications(
            `Cantidad superior a la recetada`,
            "WARNING"
          );
        } else if (!added) {
          this.$utilFront.notifications(
            "Producto no encontrado en la receta",
            "WARNING"
          );
        }
        this.clearInputs();
      }
    },

    saveStockPrescription(stockPrescription, idStock) {
      if (!this.sending) {
        this.sending = true;
        PrescriptionRequest.saveStockPrescription(stockPrescription)
          .then((res) => {
            let { code, data } = res.data;
            if (data == false) {
              this.$utilFront.notifications(
                data || "Error  al agregar el stock",
                "ERROR"
              );
            }
          })
          .catch((err) => {
            this.$utilFront.notifications(
              "Error durante la solicitud.",
              "ERROR"
            );
          })
          .finally(() => {
            this.findByIdStock(idStock);
            this.sending = false;
          });
      }
    },
    deleteStockPrescription(stockPrescription, idStock) {
      if (!this.sending) {
        this.sending = true;
        PrescriptionRequest.deleteStockPrescription(stockPrescription)
          .then((res) => {
            let { code, data } = res.data;
            if (data == false) {
              this.$utilFront.notifications(
                data || "Error  al remover el stock",
                "ERROR"
              );
            }
          })
          .catch((err) => {
            // console.log(err);
            this.$utilFront.notifications(
              "Error durante la solicitud.",
              "ERROR"
            );
          })
          .finally(() => {
            this.findByIdStock(idStock);
            this.sending = false;
          });
      }
    },
    findByIdStock(idStock) {
      StockRequest.findById({ idStock: idStock })
        .then((res) => {
          let { code, data } = res.data;
          if (code != 200) {
            this.$utilFront.notifications(
              data || "Error  al obtener el stock.",
              "ERROR"
            );
          } else {
            for (let i = 0; i < this.stocks.length; i++) {
              const element = this.stocks[i];
              if (element.value.idStock == idStock) {
                this.stocks[i].value = data;
              }
            }

            if (this.stock.idStock == idStock) {
              this.stock.quantity = data.quantity;
            }
          }
        })
        .catch((err) => {
          this.$utilFront.notifications("Error durante la solicitud.", "ERROR");
        });
    },
  },
};
</script>
